import React, { Component } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
    Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
    Typography, Avatar, IconButton, Menu, MenuItem, Divider, Paper, InputBase, Badge,
    useMediaQuery, useTheme, Tooltip
} from '@mui/material';

import {
    Home, Inventory, Category, ConfirmationNumber, Receipt, People,
    Group, BarChart, Palette, Link, Insights, Search,
    NotificationsNone, DarkModeOutlined, KeyboardArrowDown, PersonOutline,
    SettingsOutlined, CreditCardOutlined, HelpOutline, Logout,
    LightModeOutlined, PointOfSale, Menu as MenuIcon, ChevronLeft, ChevronRight
} from '@mui/icons-material';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupIcon from '@mui/icons-material/Group';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useAuth, AuthContext } from "../../context/AuthContext";

import { useColorMode } from '../../context/ThemeContext';
import TableBarIcon from '@mui/icons-material/TableBar';
import ChecklistIcon from '@mui/icons-material/Checklist';
import HelpIcon from '@mui/icons-material/Help';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Print as PrintIcon } from '@mui/icons-material';
import { apiUrl } from '../ApiUrl';

const drawerWidth = 260;
const collapsedDrawerWidth = 72; // Largura do menu encolhido

class MenuDrawerClass extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            anchorElNotifications: null,
            mobileOpen: false,
            desktopCollapsed: false,
            PrinterStatus: null,
            isPrinterConnected: null // 1. Guardamos o valor do context no state
        };
    }

    componentDidMount() {
        // Inicializa o state com os dados do context
        const isConnected = this.context.isPrinterConnected;
        console.log(this.props.user)
        this.setState({
            isPrinterConnected: isConnected,
            PrinterStatus: isConnected ? 'ativa' : 'inativa'
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // 2. Compara o valor salvo em prevState com o valor atual em this.context
        if (prevState.isPrinterConnected !== this.context.isPrinterConnected) {
            const isConnected = this.context.isPrinterConnected;

            this.setState({
                isPrinterConnected: isConnected,
                PrinterStatus: isConnected ? 'ativa' : 'inativa'
            });
        }
    }



    handleDrawerToggle = () => {
        this.setState((prevState) => ({ mobileOpen: !prevState.mobileOpen }));
    };

    handleDesktopCollapseToggle = () => {
        this.setState((prevState) => ({ desktopCollapsed: !prevState.desktopCollapsed }));
    };


    getMenuItems = (user) => {
        // 1. Se o utilizador for "Atendente", exibe apenas Frente de Caixa, Mesas e Vendas
        if (user?.role === "Atendente") {
            return [
                { type: 'subheader', text: 'ATENDIMENTO' },
                { text: 'Frente de Caixa', page: '/vender', icon: <PointOfSale /> },
                { text: 'Mesas', page: '/tables', icon: <TableBarIcon /> },
                { type: 'subheader', text: 'FINANCEIRO' },
                { text: 'Vendas', page: '/orders', icon: <Receipt /> },
            ];
        }

        // 2. Se o utilizador for "Cozinha", exibe Frente de Caixa, Mesas, Delivery e Vendas
        if (user?.role === "Cozinha") {
            return [
                { type: 'subheader', text: 'OPERAÇÕES' },
                { text: 'Frente de Caixa', page: '/vender', icon: <PointOfSale /> },
                { text: 'Mesas', page: '/tables', icon: <TableBarIcon /> },
                { text: 'Delivery', page: '/delivery', icon: <DeliveryDiningIcon /> },
                { type: 'subheader', text: 'FINANCEIRO' },
                { text: 'Vendas', page: '/orders', icon: <Receipt /> },
            ];
        }

        // 3. Menu padrão (Proprietário/Admin) construído com base em store_segment
        const baseMenu = [
            { text: 'Início', page: '/', icon: <Home /> },
        ];

        if (user && user.store_segment === "1") {
            baseMenu.push(
                { type: 'subheader', text: 'PEDIDOS' },
                { text: 'Meus Pedidos', page: '/store/orders', icon: <LocalShippingIcon /> },
            );
        }


        if (user && user.store_segment === "1") {
            baseMenu.push(
                { type: 'subheader', text: 'UTILITÁRIOS' },
                { text: 'Frente de Caixa', page: '/vender', icon: <PointOfSale /> },
            );
        }



        if (user && user.store_segment === "2") {
            baseMenu.push(
                { type: 'subheader', text: 'RESTAURANTE' },
                { text: 'Frente de Caixa', page: '/vender', icon: <PointOfSale /> },
                { text: 'Mesas', page: '/tables', icon: <TableBarIcon /> },
                { text: 'Delivery', page: '/delivery', icon: <DeliveryDiningIcon /> },
            );
        }

        if (user && user.store_segment === "4") {
            baseMenu.push(
                { type: 'subheader', text: 'ASSISTÊNCIA TÉCNICA' },
                { text: 'Frente de Caixa', page: '/vender', icon: <PointOfSale /> },
                { text: 'Checklist', page: '/checklist', icon: <ChecklistIcon /> },
            );
        }

        baseMenu.push(
            { type: 'subheader', text: 'LOJA' },
            { text: 'Produtos', page: '/produtos', icon: <Inventory /> },
            { text: 'Categorias', page: '/categories', icon: <Category /> },
        );

        if (user && user.store_segment === "2") {
            baseMenu.push(
                { text: 'Complementos', page: '/addons', icon: <PostAddIcon /> },
            );
        }

        baseMenu.push(
            { text: 'Cupons', page: '/cupons', icon: <ConfirmationNumber /> },
            { type: 'subheader', text: 'FINANCEIRO' },
            { text: 'Caixa', page: '/box', icon: <PointOfSale /> },
            { text: 'Vendas', page: '/orders', icon: <Receipt /> },
            { text: 'Compras', page: '/purchases', icon: <ShoppingCartIcon /> },
            { text: 'Clientes', page: '/clients', icon: <People /> },
            { text: 'Vendedores', page: '/sellers', icon: <Group /> },
            { text: 'Relatórios', page: '/reports', icon: <BarChart /> },
            { type: 'subheader', text: 'CATÁLOGO' },
            { text: 'Live', page: '/live', icon: <LiveTvIcon /> },
            { text: 'Aparência', page: '/appearance', icon: <Palette /> },
            { text: 'Avaliações', page: '/reviews', icon: <StarBorderIcon /> },
            { text: 'Meu Link', page: '/link', icon: <Link /> },
            { text: 'Insights', page: '/insights', icon: <Insights /> },
            { type: 'subheader', text: 'CONFIGURAÇÕES' },
            { text: 'Configurações', page: '/settings', icon: <SettingsOutlined /> },
            { text: 'Perfil de Acesso', page: '/access-profiles', icon: <GroupIcon /> },
            { text: 'Dispositivos', page: '/devices', icon: <PrintIcon /> },
            { text: 'Assinatura', page: '/billing', icon: <CreditCardOutlined /> },
            { text: 'Ferramentas', page: '/tools', icon: <AutoFixHighIcon /> },
            { text: 'Ajuda', page: '/support', icon: <HelpIcon /> }
        );

        return baseMenu;
    };

    handleProfileClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleNotificationsClick = (event) => {
        this.setState({ anchorElNotifications: event.currentTarget });
    };

    handleNotificationsClose = () => {
        this.setState({ anchorElNotifications: null });
    };

    getCurrentPageTitle = () => {
        const { location, user } = this.props;
        const menuItems = this.getMenuItems(user.role);
        const currentItem = menuItems.find(item => item.page === location.pathname);
        return currentItem ? currentItem.text : 'Início';
    };

    renderDrawerContent = (isCollapsed) => {
        const { navigate, location, user, isMobile } = this.props;
        const menuItems = this.getMenuItems(user);

        return (
            <Box sx={{ overflowX: 'hidden' }}>
                {/* LOGO & NOME DA LOJA */}
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: isCollapsed ? 'center' : 'space-between',
                        cursor: 'pointer'
                    }}
                >
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        onClick={() => { navigate('/'); if (isMobile) this.handleDrawerToggle(); }}
                    >
                        <Box sx={{ width: 32, height: 32, bgcolor: '#7c4dff', borderRadius: 1.5, flexShrink: 0 }}>
                            <img src={`${apiUrl}/store/photo/${user?.store_photo}`} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </Box>
                        {!isCollapsed && (
                            <Box sx={{ overflow: 'hidden' }}>
                                <Typography variant="subtitle2" fontWeight="bold" lineHeight={1} noWrap>FazPedido</Typography>
                                <Typography variant="caption" color="text.secondary" noWrap>{user?.store_name}</Typography>
                            </Box>
                        )}
                    </Box>

                    {/* Botão de Encolher Sidebar no Desktop */}
                    {!isMobile && !isCollapsed && (
                        <IconButton size="small" onClick={this.handleDesktopCollapseToggle}>
                            <ChevronLeft fontSize="small" />
                        </IconButton>
                    )}
                </Box>
                <Divider />

                {/* LISTA DE ITENS DO MENU */}
                <List sx={{ px: isCollapsed ? 1 : 1.5 }}>
                    {menuItems.map((item, index) => {
                        const isActive = location.pathname === item.page;

                        if (item.type === 'subheader') {
                            if (isCollapsed) return <Divider key={index} sx={{ my: 1 }} />;
                            return (
                                <Typography key={index} variant="caption" sx={{ px: 2, mt: 2, mb: 1, display: 'block', color: 'text.secondary', fontWeight: 'bold', fontSize: '0.65rem' }}>
                                    {item.text}
                                </Typography>
                            );
                        }

                        const buttonContent = (
                            <ListItemButton
                                selected={isActive}
                                onClick={() => {
                                    if (item.page) {
                                        navigate(item.page);
                                        if (isMobile) this.handleDrawerToggle();
                                    }
                                }}
                                sx={{
                                    borderRadius: 2,
                                    justifyContent: isCollapsed ? 'center' : 'initial',
                                    px: isCollapsed ? 1.5 : 2,
                                    '&.Mui-selected': { bgcolor: '#f3eaff', color: '#7c4dff' },
                                    '&.Mui-selected .MuiListItemIcon-root': { color: '#7c4dff' }
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: isCollapsed ? 0 : 40, mr: isCollapsed ? 0 : 0, justifyContent: 'center', fontSize: 20 }}>
                                    {item.icon}
                                </ListItemIcon>
                                {!isCollapsed && (
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: isActive ? 'bold' : 'medium', noWrap: true }}
                                    />
                                )}
                                {!isCollapsed && item.badge && (
                                    <Typography sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', px: 0.8, py: 0.2, borderRadius: 1, fontSize: '0.65rem', fontWeight: 'bold' }}>
                                        {item.badge}
                                    </Typography>
                                )}
                            </ListItemButton>
                        );

                        return (
                            <ListItem key={index} disablePadding sx={{ mb: 0.5 }}>
                                {isCollapsed ? (
                                    <Tooltip title={item.text} placement="right">
                                        {buttonContent}
                                    </Tooltip>
                                ) : (
                                    buttonContent
                                )}
                            </ListItem>
                        );
                    })}
                </List>
            </Box>
        );
    };

    render() {
        const { anchorEl, anchorElNotifications, mobileOpen, desktopCollapsed } = this.state;
        const open = Boolean(anchorEl);
        const openNotifications = Boolean(anchorElNotifications);
        const { navigate, user, logout, mode, toggleColorMode, children, isMobile } = this.props;

        // Determina a largura atual baseada no estado do desktop
        const currentDesktopWidth = desktopCollapsed ? collapsedDrawerWidth : drawerWidth;

        return (
            <Box sx={{ display: 'flex', bgcolor: '#fbfbfb', minHeight: '100vh' }}>
                {/* DRAWER RESPONSIVO */}
                <Box
                    component="nav"
                    sx={{ width: { md: currentDesktopWidth }, flexShrink: { md: 0 }, transition: 'width 0.2s' }}
                >
                    {/* Versão Mobile (Drawer Temporário) */}
                    {isMobile ? (
                        <Drawer
                            variant="temporary"
                            open={mobileOpen}
                            onClose={this.handleDrawerToggle}
                            ModalProps={{ keepMounted: true }}
                            sx={{
                                '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
                            }}
                        >
                            {this.renderDrawerContent(false)}
                        </Drawer>
                    ) : (
                        /* Versão Desktop (Fixo / Encolhível) */
                        <Drawer
                            variant="permanent"
                            sx={{
                                '& .MuiDrawer-paper': {
                                    width: currentDesktopWidth,
                                    boxSizing: 'border-box',
                                    borderRight: '1px solid #f0f0f0',
                                    transition: 'width 0.2s',
                                    overflowX: 'hidden'
                                },
                            }}
                            open
                        >
                            {this.renderDrawerContent(desktopCollapsed)}
                        </Drawer>
                    )}
                </Box>

                {/* CONTEÚDO PRINCIPAL + HEADER */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100vh',
                        overflow: 'hidden',
                        width: { md: `calc(100% - ${currentDesktopWidth}px)` },
                        transition: 'width 0.2s'
                    }}
                >
                    {/* HEADER FIXO NO TOPO */}
                    <Box sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        px: { xs: 2, md: 4 }, py: 2, borderBottom: '1px solid #f0f0f0', bgcolor: 'white',
                        position: 'sticky',
                        top: 0,
                        height: 71,
                        zIndex: 1100,
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {/* Botão de Abrir Menu Mobile */}
                            {isMobile && (
                                <IconButton onClick={this.handleDrawerToggle} edge="start" sx={{ mr: 1 }}>
                                    <MenuIcon />
                                </IconButton>
                            )}

                            {/* Botão de Expandir no Desktop (aparece quando encolhido) */}
                            {!isMobile && desktopCollapsed && (
                                <IconButton onClick={this.handleDesktopCollapseToggle} edge="start" sx={{ mr: 1 }}>
                                    <ChevronRight />
                                </IconButton>
                            )}

                            <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight="bold" noWrap>
                                {this.getCurrentPageTitle()}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>


                            <IconButton
                                size="small"

                                onClick={() => {
                                    // Ação ao clicar no botão de impressão
                                }}
                            >

                                <Badge badgeContent={3} color={this.state.isPrinterConnected ? "success" : "error"} variant="dot">
                                    <PrintIcon fontSize="small" />
                                </Badge>



                            </IconButton>

                            <IconButton size="small" onClick={this.handleNotificationsClick}>

                                <NotificationsNone fontSize="small" />

                            </IconButton>

                            {/* BOTÃO PERFIL */}
                            <Box
                                onClick={this.handleProfileClick}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', ml: 0.5 }}
                            >
                                <Avatar src={user?.photo} sx={{ width: 32, height: 32 }} />
                                {!isMobile && (
                                    <Box>
                                        <Typography variant="caption" fontWeight="bold" display="block">Olá, {user?.name}</Typography>
                                        <Typography variant="caption" color="text.secondary">Seu perfil</Typography>
                                    </Box>
                                )}
                                <KeyboardArrowDown fontSize="small" />
                            </Box>

                            {/* DROPDOWN DE NOTIFICAÇÕES */}
                            <Menu
                                anchorEl={anchorElNotifications}
                                open={openNotifications}
                                onClose={this.handleNotificationsClose}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        width: 280, mt: 1.5, borderRadius: 2, border: '1px solid #f0f0f0',
                                        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)'
                                    }
                                }}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                <Box sx={{ px: 2, py: 1.5 }}>
                                    <Typography variant="subtitle2" fontWeight="bold">Notificações</Typography>
                                </Box>
                                <Divider />
                                <Box sx={{ p: 1, textAlign: 'center' }}>
                                    <Typography variant="caption" color="primary" sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                        Marcar todas como lidas
                                    </Typography>
                                </Box>
                            </Menu>

                            {/* DROPDOWN DO PERFIL */}
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={this.handleClose}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        width: 220, mt: 1.5, borderRadius: 2, border: '1px solid #f0f0f0',
                                        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)'
                                    }
                                }}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                <Box sx={{ px: 2, py: 1.5 }}>
                                    <Typography variant="subtitle2" fontWeight="bold">{user?.name}</Typography>
                                    <Typography variant="caption" color="text.secondary">{user?.email}</Typography>
                                </Box>
                                <Divider />
                                <MenuItem onClick={() => { navigate('/settings'); this.handleClose(); }} sx={{ fontSize: '0.85rem', py: 1 }}>
                                    <ListItemIcon><PersonOutline fontSize="small" /></ListItemIcon> Meu Perfil
                                </MenuItem>
                                <MenuItem onClick={() => { navigate('/settings'); this.handleClose(); }} sx={{ fontSize: '0.85rem', py: 1 }}>
                                    <ListItemIcon><SettingsOutlined fontSize="small" /></ListItemIcon> Configurações
                                </MenuItem>
                                <MenuItem onClick={() => { navigate('/billing'); this.handleClose(); }} sx={{ fontSize: '0.85rem', py: 1 }}>
                                    <ListItemIcon><CreditCardOutlined fontSize="small" /></ListItemIcon> Assinatura
                                </MenuItem>
                                <MenuItem onClick={this.handleClose} sx={{ fontSize: '0.85rem', py: 1 }}>
                                    <ListItemIcon><HelpOutline fontSize="small" /></ListItemIcon> Ajuda
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={async () => {
                                    this.handleClose();
                                    await logout();
                                }} sx={{ fontSize: '0.85rem', py: 1, color: '#f44336' }}>
                                    <ListItemIcon><Logout fontSize="small" sx={{ color: '#f44336' }} /></ListItemIcon> Sair
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Box>

                    {/* ÁREA DE CONTEÚDO QUE ROLA */}
                    <Box sx={{ p: this.props.deveRemoverPadding ? 0 : { xs: 2, md: 3 }, flexGrow: 1, overflowY: 'auto' }}>
                        {children}
                    </Box>
                </Box>
            </Box>
        );
    }
}

// Wrapper funcional com Hooks para detectar tela Mobile/Desktop
export default function MenuDrawer(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout, user } = useAuth();
    const { mode, toggleColorMode } = useColorMode();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const rotasSemPadding = ['/vender', '/tables'];
    const deveRemoverPadding = rotasSemPadding.includes(location.pathname);

    return (
        <MenuDrawerClass
            {...props}
            navigate={navigate}
            location={location}
            user={user}
            logout={logout}
            mode={mode}
            isMobile={isMobile}
            deveRemoverPadding={deveRemoverPadding}
            toggleColorMode={toggleColorMode}
        />
    );
}